export const FEATURE_PREMIUM_COMPANY_PROFILE = 'premium-company-profile';
export const FEATURE_PROMOTED_JOBS = 'promoted-jobs';
export const TOOL_ADOPTION_STAGE = 'adoption-stages';
export const STACK_TAGS = 'tags';
export const STACK_APPLICATIONS = 'stack-apps';
export const STACK_NOTIFICATION = 'stack-notification';
export const LICENSE = 'licenses';
